import embedHu from "./locales/hu.json";
import embedEn from "./locales/en.json";

/**
 * A beágyazott naptár lépés-komponenseinek szövegei (kiegészítő adatok, számlázás,
 * megjegyzés), amikor a PORTÁL foglalója használja őket.
 *
 * A portál szövegtára a szerverről jön, és a `translations.vue` minden betöltéskor LECSERÉLI a
 * teljes tárat — ami utólag bekerült, elveszne. Ezért a lépések szövegei alapként mennek a
 * cserébe: amit a szerver is ismer, azt a szerveré írja felül.
 */
const pick = (messages) => ({
    billing: messages.billing,
    extra: messages.extra,
    note: messages.note,
    common: {
        choose: messages.common?.choose,
        continue: messages.common?.continue,
        optionalSuffix: messages.common?.optionalSuffix,
        saving: messages.common?.saving,
    },
});

const byLocale = {hu: pick(embedHu), en: pick(embedEn)};

const isObject = (value) => value && typeof value === "object" && !Array.isArray(value);

const mergeDeep = (base, over) => {
    const result = {...base};

    Object.entries(over || {}).forEach(([key, value]) => {
        result[key] = isObject(value) && isObject(result[key]) ? mergeDeep(result[key], value) : value;
    });

    return result;
};

/** A szerver fordításai, a lépés-szövegekkel mint alappal. */
export function withStepMessages(locale, translations) {
    return mergeDeep(byLocale[locale] || byLocale.hu, translations || {});
}
